"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
var react_1 = __importDefault(require("react"));
function Hls(_a) {
    var livestream = _a.livestream, setLivestream = _a.setLivestream;
    var pullzones = ra_fetch_1.useApi('media').index('pullzones')[0];
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Texts.Heading, { className: 'mb-4', type: 'h3' }, "Pull zone informatie"),
        react_1.default.createElement(storybook_1.Forms.Select, { className: 'mb-4', value: livestream.pullzone_id, onChange: function (pullzone_id) { return setLivestream(__assign(__assign({}, livestream), { pullzone_id: pullzone_id })); } },
            react_1.default.createElement("option", { value: '' }, "Kies een pull zone"),
            pullzones.data.map(function (pullzone, index) { return react_1.default.createElement("option", { key: index, value: pullzone.id }, pullzone.source_url); })),
        react_1.default.createElement(storybook_1.Forms.Input, { placeholder: 'HLS stream url', value: livestream.source_path, onChange: function (source_path) { return setLivestream({ source_path: source_path }); } }),
        react_1.default.createElement(storybook_1.Texts.Small, { className: 'mt-4' }, "Je hebt gekozen voor HLS, onder meer geschikt voor automatische camera's, hiervoor worden geen kosten in rekening gebracht. Vraag de pull zone informatie op bij jouw camera leverancier."));
}
exports.default = Hls;
